
import { useState, useEffect } from "react";
import "../Styles-css/Navbar.css"; // External CSS file
import logo from "../Image/lg (2).png"
const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [submenuOpen, setSubmenuOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false); // <-- new

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header>
      
      <div className={`header-bottom ${scrolled ? "scrolled" : ""}`}>

        <h1 className="logo">
                  <img src={logo} alt="logo" className="logo-img"/> 
        </h1>
        <div className={`menu-toggle`} onClick={toggleMenu}>
          &#9776;
        </div>

        <nav className={menuOpen ? "active" : ""}>
          <a href="home" className="active">Home</a>
          <a href="about">About</a>
          <a href="service">Service</a>
          <a href="contact">Contact Us</a>
          <div
            className="nav-item has-submenu"
            onClick={() => setSubmenuOpen(!submenuOpen)}
          >
            <a href="#" className="submenu-toggle">More ^</a>
            {submenuOpen && (
              <div className="submenu">
                <a href="terms">Terms and Conditions</a>
                <a href="policy">Privacy Policy</a>
                <a href="cancellationPolicy">Cancellation Policy</a>
              </div>
            )}
          </div>
          <button className="nav-login-btn"><a href="tel:7898622741">Call Now</a></button>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
